import { useSearchParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { queryClient } from '../../../../shared/queryClient';
import { AxiosError } from 'axios';
import TableUnit from './TableUnit';
import * as C from '../../../ui/common/CommonStyles';

import Swal from 'sweetalert2';
import { AxiosCommonError } from '../../../../shared/types';
import { Group, Pagination } from '@mantine/core';
import CustomSearch from '../../../ui/search/customSearch';
import { useCustomSearch } from '../../../../shared/hook/useCustomSearch';
import { cleanParams } from '../../../../shared/utils/cleanParams';
import { useDataPointOrderList } from '../hooks/dataPointService';
import { relayPointApis } from '../../../../shared/apis/relayPoint/apis';

const options = [
  { value: 'all', label: 'All' },
  { value: 'userId', label: '유저 아이디' },
  { value: 'deviceId', label: '디바이스 번호' },
];

const DataPointRefund = () => {
  const statusCd = 3;
  // 클라이언트단 url parameter 설정
  const [searchParams, setSearchParams] = useSearchParams('');
  const searchWord = searchParams.get('keyword') || '';
  const searchType = searchParams.get('searchType') || 'all';
  const page = searchParams.get('page') || '1';
  const size = searchParams.get('size') || '10';

  const { inputRef, handleSearch, resetWord, handleSearchType, resetSearchInput } = useCustomSearch({
    initType: 'all',
  });

  // 데이터 포인트 결제 리스트 조회 쿼리
  const { data: getDataPointRefundListQuery } = useDataPointOrderList({
    queryKey: ['loadDataPointRefundListQuery', page, size, searchType, searchWord, statusCd],
    query: {
      searchType,
      searchWord,
      page: Number(page),
      size: Number(size),
      statusCd,
    },
  });

  // 페이지네이션 처리를 위한 토탈값
  const total: number = getDataPointRefundListQuery?.data.count;

  // 환불요청 승인 mutate
  const { mutate: approveRefundDatapointMutate } = useMutation(
    (data: { impUid: string; amount: number }) => relayPointApis.postRelayPointRefund(data),
    {
      onSuccess: () => {
        Swal.fire({
          icon: 'success',
          title: '환불요청이 승인되었습니다.',
        }).then(() => {
          queryClient.invalidateQueries({
            queryKey: ['loadDataPointRefundListQuery'],
          });
        });
      },
      onError: (error: AxiosError<AxiosCommonError>) => {
        Swal.fire({
          icon: 'error',
          title: '예기치못한 오류로 승인에 실패했습니다.',
        });
      },
    },
  );

  // 환불 요청 승인
  const approveRequestCheck = (imp_uid: string, amount: number) => {
    return () => {
      if (window.confirm('환불요청을 승인하시겠습니까?')) {
        approveRefundDatapointMutate({ impUid: imp_uid, amount });
        return true;
      } else {
        return false;
      }
    };
  };

  return (
    <div>
      <C.TitleBox>
        <div className="title">환불요청 리스트</div>
      </C.TitleBox>
      <C.ListBox>
        <C.Toolbar>
          <CustomSearch
            resetSearch={resetWord}
            resetSearchInput={resetSearchInput}
            searchType={searchType}
            setSearchType={handleSearchType}
            inputRef={inputRef}
            handleSearch={handleSearch}
            searchOptions={options}
          />
        </C.Toolbar>
        <C.TableWrap>
          <TableUnit data={getDataPointRefundListQuery} approveRequestCheck={approveRequestCheck} />
          {total > 0 ? (
            <Group justify="center" mt="md">
              <Pagination
                total={Math.ceil(total / Number(size))}
                value={Number(page)}
                onChange={(value) => {
                  const currentParams = Object.fromEntries(searchParams.entries());
                  setSearchParams(
                    cleanParams({
                      ...currentParams,
                      page: String(value),
                    }),
                  );
                }}
              />
            </Group>
          ) : null}
        </C.TableWrap>
      </C.ListBox>
    </div>
  );
};

export default DataPointRefund;
